export default "__VITE_ASSET__DRMHHEEE__"